export const BookingStatusConfig: any = {
    open: 'Available',
    approved: 'Approved',
    pending: 'Approval Pending',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled'
}
export const BoothBookingTypeConfig: any = {
    bare_shell_stall: 'Bare Stall',
    panel_shell_stall: 'Shell Stall',
    open_shell_stall: 'Open Stall',
}
export const BookingTypeConfig: any = {
    pen: 'Pencil Booking',
    final: 'Final Booking'
}

export const UserTypeConfig: any = {
    admin: 'Admin',
    constro_manger: 'Constro Manager',
    account: 'Account',
    sales_agent: 'Sales Associate',
    company: 'Exhibitor',
    visitor: 'Visitor',
    awards_admin: 'Awards Admin',
    safety_award_account: 'Awards Account Admin'
}

export const BookingTransactionTypeConfig: any = {
    NEFT: 'NEFT',
    cheque: 'Cheque'
}

export const BookingTransactionStatusConfig: any = {
    pending: 'Pending',
    verified: 'Verified',
    rejected: 'Rejected'
}

export const VidyarthiAwardStatusConfig: any = {
    endorsement_pending: 'Endorsement Pending',
    verification_pending: 'Verification Pending',
    endorsement_approved: 'Endorsement Approved',
    endorsement_rejected: 'Endorsement Rejected'
}

export const VidyarthiAwardDisciplineConfig: any = {
    architecture: {
        label: 'Architecture',
        course: {
            UG: { label: 'UG', area: 'Fourth year / Final year project' },
            PG: { label: 'PG', area: 'Final year Thesis Project' },
        },
        subject: ['Urban Insert', 'Housing', 'Town & Country Planning', 'Urban Design', 'Conservation', 'Construction & Project Management', 'Landscape Architecture']
    },
    civil_engineering: {
        label: 'Civil Engineering',
        course: {
            UG: { label: 'UG', area: 'Third or Final year project' },
            PG: { label: 'PG', area: 'Post Graduate Project' },
            diploma: { label: 'Diploma', area: 'Final year Diploma project' }
        },
        subject: ['Construction Management', 'Geo-Technical Engineering', 'Structural Engineering', 'Environmental Engineering', 'Water Resource Engineering']
    },
    any_engineering_branch: {
        label: 'Any Engineering Branch',
        course: {
            UG: { label: 'UG', area: 'Third or Final year projects' },
            PG: { label: 'PG', area: 'Any of the years projects' },
        },
        subject: ['Project Realted to Civil Engineering and Architecture']
    },
    m_planning: {
        label: 'M. Planning',
        course: {
            PG: { label: 'PG', area: 'Final year Thesis Project' }
        },
        subject: ['Final year Thesis Project']
    },

}

export const UserTypeWisePagesConfig: any = {
    admin: ['/admin/special-invitee-badge-print','/admin/', '/admin/statistics/', '/admin/book-booth/', '/admin/booking/', '/admin/booking/detail/', '/admin/vidyarthi-awards/', '/admin/vidyarthi-awards/detail/', '/admin/safety-awards/', '/admin/safety-awards/detail/', '/admin/exhibitors/', '/admin/exhibitors/details/', '/admin/visitors/', '/admin/visitors/details/', '/admin/master/booth-master/', '/admin/master/coupon-master/', '/admin/master/sales-agent/', '/admin/safety-awards/payment-report/', '/admin/safety-awards/evaluation-report/', '/admin/committee-member',"/admin/master/contact-enquiry","/admin/master/booking-request","/admin/master/notifications","/admin/vidyarthi-awards/assignment","/admin/vidyarthi-awards/evaluation-report","/admin/vidyarthi-awards/award-winners",'/admin/jobs/','/admin/cvs/',"/admin/contact-inquiry-pcerf","/admin/contact-inquiry-training","/admin/technical-article-inquiry","/admin/student-internship-inquiry","/admin/youcons", '/admin/exhibitor-badge-print', '/admin/visitor-badge-print','/admin/entry-gate', '/admin/exit-gate',"/admin/visitor-feedback","/admin/exhibitor-feedback",'/admin/create-visitor','/admin/cash-counter-visitor-list', '/admin/create-upi-visitor','/admin/upi-card-counter-visitor-list'],
    constro_manger: ['/admin/', '/admin/statistics/', '/admin/book-booth/', '/admin/booking/', '/admin/booking/detail/', '/admin/exhibitors/', '/admin/exhibitors/details/', '/admin/visitors/', '/admin/visitors/details/', '/admin/master/booth-master/',"/admin/master/contact-enquiry","/admin/master/booking-request","/admin/master/coupon-master", '/admin/exhibitor-badge-print', '/admin/visitor-badge-print', '/admin/entry-gate', '/admin/exit-gate'],
    account: ['/admin/', '/admin/statistics/', '/admin/booking/', '/admin/booking/detail/','/admin/exhibitors/', '/admin/exhibitors/details/', '/admin/visitors/', '/admin/visitors/details/'],
    sales_agent: ['/admin/', '/admin/book-booth/', '/admin/booking/', '/admin/booking/detail/'],
    company: ['/user/exhibitor', '/feedback'],
    visitor: ['/user/visitor', '/feedback'],
    safety_award_cordinator: ['/admin/', '/admin/safety-awards/', '/admin/safety-awards/detail/'],
    awards_admin: ['/admin/', '/admin/vidyarthi-awards/', '/admin/vidyarthi-awards/detail/', '/admin/safety-awards/', '/admin/safety-awards/detail/', '/admin/safety-awards/payment-report/', '/admin/safety-awards/evaluation-report/', '/admin/committee-member',"/admin/vidyarthi-awards/evaluation-report","/admin/vidyarthi-awards/assignment","/admin/vidyarthi-awards/award-winners"],
    safety_award_account: ['/admin/', '/admin/safety-awards/', '/admin/safety-awards/detail/', '/admin/safety-awards/payment-report/'],
    vidyarthi_jury :['/jury/vidyarthi-award-jury', '/user/jury'],
    counter_volunteer: ['/admin/exhibitor-badge-print', '/admin/visitor-badge-print'],
    cash_counter_volunteer: ['/admin/','/admin/exhibitor-badge-print', '/admin/visitor-badge-print','/admin/create-visitor','/admin/cash-counter-visitor-list'],
    upi_counter_volunteer: ['/admin/', '/admin/create-upi-visitor','/admin/upi-card-counter-visitor-list'],
    security: ['/admin/entry-gate', '/admin/exit-gate'],
    ctl_volunteer: ['/admin/visitor-process-listing', '/admin/success-user-not-created-listing','/admin/success-user-not-created-listing','/admin/free-reg-users','/admin/non-reg-users','/admin/category-report'],
    pharoscion_vendor: ['/admin/exhibitors', '/admin/visitors', '/admin/master/booking-request', '/admin/exhibitors/details/', '/admin/visitors/details/',]
}


export const SafetyAwardStatusConfig: any = {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
}

export const SafetyAwardPaymentStatusConfig: any = {
    payment_pending: 'Payment Pending',
    payment_done: 'Payment Done',
    payment_rejected: 'Payment Rejected'
}

export const SafetyAwardRatingStatusConfig: any = {
    pending: 'Pending',
    complete: 'Completed',
    in_progress: 'In Progress',
    skip: 'Skipped',
}

export const ContactInquiryStatusConfig: any = {
    open: 'Open',
    closed: 'Closed',
    pending: 'Pending',
    rejected: 'Rejected',
}

export const SafetyAwardsCategoryConfig: any = {
    master_category: {
        label: 'Master Category',
        description: [
            "Only those participants are eligible as per PCERF's guidelines and who have received an invitation from PCERF. This is based on consistent participation in previous awards and the number of awards they have won."
        ]

    },
    building_contractors_A: {
        label: 'Building Contractors - A',
        description: [
            'Project value above 100 Cr.'
        ]
    },
    building_contractors_B: {
        label: 'Building Contractors - B',
        description: [
            'Project Value Less than 100Cr.',
        ]
    },
    building_contractors_C: {
        label: 'Building Contractors – C',
        description: [
            'Project Value up to 50 Cr.'
        ]
    },
    building_developers_A: {
        label: 'Building Developers - A',
        description: [
            'Project Value Above 300 Cr.'
        ]
    },
    building_developers_B: {
        label: 'Building Developers - B',
        description: [
            'Project Value Less than 300 Cr.'
        ]
    },
    building_developers_C: {
        label: 'Building Developers - C',
        description: [
            'Project value up to 50 Cr.'
        ]
    },
    industrial_projects: {
        label: 'Industrial Projects',
        description: [
            'Any site engaged in industrial buildings, development of industrial Area',
            'No Project cost limitations.'
        ]
    },
    infra_structure: {
        label: 'Infra-Structure',
        description: [
            'Projects related to infrastructure development like Flyovers, Metro rail, Highway Projects, STP, Sea Link Projects, Tunnels, River Front Projects, Water Supply, Heritage restoration Projects etc.',
            'No Project cost limitations.'
        ]
    },
    regional_category: {
        label: 'Regional Category',
        description: [
            'Regional Contractors outside Pune District or Company Registrationoutside Pune.',
            'No Project cost limitations.',
            'Introductory fees for this year only.'
        ]
    },
}



export  const categoryConfig = [
    { name: 'General Visitors', key: 'general_visitors' },
    { name: 'Academia Student and Staff', key: 'academia_student_and_staff' },
    { name: 'PCERF Members and Staff', key: 'pcerf_members_office_staff' },
    { name: 'Special Invitees', key: 'special_invitees_awards_seminars_guests' },
    { name: 'Government Officials', key: 'pmrda_pcmc_pwd_govt_officials' },
    { name: 'Co-sponsors', key: 'co_sponsors_associations_members' },
    { name: 'Service Providers', key: 'service_providers_vendors' },
    { name: 'Exhibitors', key: 'exhibitor' },
    { name: 'Others', key: 'other' },
    { name: 'Company', key: 'company' },
];
